export enum SubscriptionPlanType {
  BASIC = 'basic',
  PREMIUM = 'premium',
}
